import * as React from 'react';
import { AppStoreMinimalApp } from '../../types';
import { antGrey, runwayColors } from '../styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import appleFilledColorUrl from '../../../assets/apple-filled-color.svg';
import androidFilledColorUrl from '../../../assets/android-filled-color.svg';
import { isIosPlatform, platformDifferentiatedAppId } from '../../helpers';
import Image from 'antd/lib/image';

interface SelectAppComponentProps extends AppStoreMinimalApp {
    isSelected: boolean;
    onSelectApp: (isSelectedBoolean: boolean, platformedAppId: string) => void;
}

const SelectAppComponent: React.FC<SelectAppComponentProps> = (props: SelectAppComponentProps) => {
    const [isHovering, setIsHovering] = React.useState(false);

    const isSelectedStyle: React.CSSProperties = {
        borderColor: runwayColors.info,
        borderWidth: 3,
        borderStyle: 'solid',
    };
    const extraStyles = props.isSelected ? isSelectedStyle : {};
    const hoverStyles = isHovering ? { backgroundColor: antGrey.grey3 } : {};
    const platformedAppId = platformDifferentiatedAppId(props.appId, props.appPlatform); // needed to differentiate apps with the same apId, different platforms

    return (
        <div
            style={{
                backgroundColor: antGrey.grey4,
                borderRadius: 16,
                padding: 16,
                display: 'flex',
                ...extraStyles,
                ...hoverStyles,
            }}
            onClick={() => props.onSelectApp(!props.isSelected, platformedAppId)}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        >
            <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1, minWidth: 0 }}>
                {props.appIconUrl && (
                    <div style={{ borderRadius: 8, flexShrink: 0, display: 'flex', overflow: 'hidden' }}>
                        <Image
                            src={props.appIconUrl}
                            width={40}
                            height={40}
                            fallback={'https://runway-img.s3.us-east-2.amazonaws.com/app-empty.png'}
                            preview={false}
                        />
                    </div>
                )}
                <div
                    style={{
                        flexGrow: 1,
                        marginLeft: 12,
                        marginRight: 12,
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: 0,
                    }}
                >
                    <Text strong ellipsis>
                        {props.appName}
                    </Text>
                    <Text type="secondary" ellipsis>
                        {props.appId}
                    </Text>
                </div>
                <img
                    src={isIosPlatform(props.appPlatform) ? appleFilledColorUrl : androidFilledColorUrl}
                    width={32}
                    height={32}
                />
            </div>
        </div>
    );
};

export default SelectAppComponent;
